import { requestApi } from "@/api/core";
import { dynamicDispatcher } from "@/libs/util";

export const getExecutionSkipLog = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "TaskInUser/GetExecutionSkipLog",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getExecutionById = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "TaskInUser/GetExecutionById",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const postExecution = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "TaskInUser/postExecution",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getTaskUsers = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "TaskInUser/GetInheritedList",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getShareData = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "TaskInUser/GetShareData",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const postShareData = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "TaskInUser/PostShareData",
      method: "POST",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getTaskPinnedUsers = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "TaskInUser/GetPinnedList",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};
